import Switch from "common/Buttons/Switch";
import Text from "common/Typography/Text";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import {
  SIGNAL_CANCEL_ON_TP_REACHED_HELPER_TOOLTIP,
  TRADE_CANCEL_ON_TP_REACHED_HELPER_TOOLTIP,
} from "@shared/common/Tooltips/constants";
import { ErrorText } from "features/bots/common/styles";
import { CancelOnTpReachedProps } from "@shared/features/tradingTerminal/common/types";
import styled, { useTheme } from "styled-components";
import OverrideTypeToggle from "features/bots/BotForm/common/OverrideTypeToggle.tsx";
import { OverrideType } from "@shared/features/bots/BotForm/common/types.ts";
import React, { useContext } from "react";
import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const CancelOnTpReached = ({
  value,
  onChange,
  isBreakout,
  errorMessage,
}: CancelOnTpReachedProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);
  const theme = useTheme();
  const { isSignal } = useContext(TradingTerminalContext)!;
  const tooltipData = isSignal
    ? SIGNAL_CANCEL_ON_TP_REACHED_HELPER_TOOLTIP
    : TRADE_CANCEL_ON_TP_REACHED_HELPER_TOOLTIP;

  const getToggle = () => {
    if (isSignal) {
      const parsedValue =
        value === null
          ? OverrideType.DYNAMIC
          : value
          ? OverrideType.PERSONAL
          : OverrideType.OFF;
      return (
        <OverrideTypeToggle
          onClick={(overrideType) => {
            if (overrideType && overrideType in OVERRIDE_TO_VALUE) {
              onChange(OVERRIDE_TO_VALUE[overrideType]);
            }
          }}
          options={Object.keys(OVERRIDE_TO_VALUE) as OverrideType[]}
          selectedOption={parsedValue}
          showPersonalAsOn={true}
        />
      );
    } else {
      return <Switch checked={!!value} onClick={onChange} size="small" />;
    }
  };

  return (
    <>
      <Wrapper>
        <Text>
          {t(
            isBreakout
              ? "tooltips.close_on_stop_before_entry"
              : "tooltips.close_on_tp_before_entry"
          )}
        </Text>
        <HelperTooltip
          {...tooltipData}
          articleId={isSignal ? "5814956" : undefined}
          iconStyle={{ color: theme.colors.primaryText }}
          containerStyle={{ marginLeft: 0 }}
          description={t(tooltipData.description)}
          title={t(tooltipData.title)}
        />
        {getToggle()}
      </Wrapper>
      {/* New look: no empty error line adding space under the switch. */}
      {(!theme.isNewLook || !!errorMessage) && (
        <ErrorText>{errorMessage}</ErrorText>
      )}
    </>
  );
};

export default CancelOnTpReached;

const OVERRIDE_TO_VALUE = {
  [OverrideType.OFF]: false,
  [OverrideType.DYNAMIC]: null,
  [OverrideType.PERSONAL]: true,
} as const;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  row-gap: 8px;
  flex-wrap: wrap;
`;
